import flow from 'lodash/flow'

const fixCustomReturns = goals => {
  Object.keys(goals).forEach(key => {
    if (!Object.keys(goals[key]).includes('customInvestmentPeriodEquity')) {
      goals[key] = {
        ...goals[key],
        customInvestmentPeriodEquity: null,
        customSpendingPeriodEquity: null,
      }
    }
  })
  return goals
}

const fixMissingCategory = goals => {
  const iconCategoryMapping = {
    retirement: 'retirement',
    book: 'education',
    holiday: 'holidays',
    purchase: 'purchase',
    freedom: 'freedom',
  }
  Object.keys(goals).forEach(key => {
    if (!goals[key].category) {
      goals[key] = {
        ...goals[key],
        category: iconCategoryMapping[goals[key].icon],
      }
    }
  })
  return goals
}

const addScalingFlag = goals => {
  for (const goal in goals) {
    if (!goals[goal].hasOwnProperty('scaling')) {
      goals[goal] = {
        ...goals[goal],
        scaling: true,
      }
    }
  }
  return goals
}

export default flow([
  goals => fixCustomReturns(goals),
  goals => fixMissingCategory(goals),
  goals => addScalingFlag(goals),
])



// WEBPACK FOOTER //
// ./src/utils/makeGoalsCompatible.js